import { Box, Center, Text, Stack } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PushableButton from "../../components/buttons/PushableButton";

const roles = [
  { label: "Inventor", color: "blue.500" },
  { label: "Visionary", color: "purple.500" },
  { label: "Polymath", color: "orange.600" },
  { label: "Innovator", color: "green.500" },
  { label: "Engineer", color: "red.600" },
  { label: "Entrepreneur", color: "red.600" },
];

const Hero = () => {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % roles.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  const currentRole = roles[index];

  // Determine "a" or "an" based on first letter
  const article = ["A", "E", "I", "O", "U"].includes(
    currentRole.label[0].toUpperCase()
  )
    ? "an"
    : "a";

  return (
    <Box
      position={"relative"}
      bg="#e2e2e2"
      py={{ base: 20, md: 32 }}
      height="100vh"
      px={4}
    >
      <Center>
        <Stack spacing={8} maxW="5xl" textAlign="center" align="center">
          <Text
            color="black"
            fontWeight="semibold"
            fontSize="4xl"
            letterSpacing="wide"
            fontFamily="serif"
          >
            bellu.ai
          </Text>

          {/* Headline */}
          <Text
            fontSize={{ base: "5xl", md: "7xl" }}
            fontWeight="bold"
            color="gray.800"
          >
            <Text as="span">Learn like {article} </Text>
            <AnimatePresence mode="wait">
              <motion.span
                key={"learn-" + currentRole.label}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.5 }}
                style={{ display: "inline-block", marginLeft: "0.4rem" }}
              >
                <Text as="span" color={currentRole.color}>
                  {currentRole.label}.
                </Text>
              </motion.span>
            </AnimatePresence>
            <br />
            <Text px={"3rem"} as="span">
              Be One
            </Text>
            {/* <AnimatePresence mode="wait">
              <motion.span
                key={"be-" + currentRole.label}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.5 }}
                style={{ display: "inline-block", marginLeft: "0.2rem" }}
              >
                <Text as="span" color={currentRole.color}>
                  {currentRole.label}.
                </Text>
              </motion.span>
            </AnimatePresence> */}
          </Text>

          {/* Subheadline */}
          <Text color="gray.700" mt={2}>
            ⚡Exclusive early access — limited to our first <b>100</b> curious
            minds.
          </Text>

          <PushableButton
            title="Get Started"
            onClick={() => navigate("/dashboard/learn")}
          />
          <Text
            position={"absolute"}
            bottom={"10"}
            px={"1rem"}
            maxW={"43rem"}
            fontSize={{ base: "md", md: "lg" }}
            color="gray.600"
          >
            Explore the why behind the future — across AI, robotics, quantum,
            and more — through hands-on, visual learning. —{" "}
            <b>in just 15 minutes a day.</b>
          </Text>
        </Stack>
      </Center>
    </Box>
  );
};

export default Hero;
